import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=b6132a5e&scoped=true&"
import script from "./resources.vue?vue&type=script&lang=js&"
export * from "./resources.vue?vue&type=script&lang=js&"
import style0 from "./resources.vue?vue&type=style&index=0&id=b6132a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6132a5e",
  null
  
)

export default component.exports